import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import { getFirestore } from "firebase/firestore";
import { apiRequest } from "../apiService/allApi";

const firebaseConfig = {
  apiKey: "AIzaSyDKOAemO9lvrcYA3ACBcxYdA2831dywAi8",
  authDomain: "kingmastar-ecc65.firebaseapp.com",
  projectId: "kingmastar-ecc65",
  storageBucket: "kingmastar-ecc65.firebasestorage.app",
  messagingSenderId: "199458629235",
  appId: "1:199458629235:web:29cc1e5c451ce160636c06",
  measurementId: "G-HKG1RMPS73",
};

const access_token = localStorage.getItem("token");
const fcm = localStorage.getItem("fcm");
export const app = initializeApp(firebaseConfig);

export const messaging = getMessaging(app);

const db = getFirestore(app);

export const getTokens = async (setTokenFound) => {
  try {
    const currentToken = await getToken(messaging, {
      vapidKey:
        "BNycKplks7AZ2V26TkEf4lgcVPvLyYwddrs2Ej_K3hPo6x5rZzkSwJwwqRiVFP95joLO8oe5YhiyPLODmUyXdfk",
    });

    if (currentToken) {
      if (access_token && fcm !== currentToken) {
        const headers = {
          Authorization: `Bearer ${access_token}`,
        };
        try {
          const res = await apiRequest(`updateToken?firebaseToken=${currentToken}`,"GET",null,headers)

          localStorage.setItem("fcm", currentToken);
        } catch (e) {
        }
      }
      setTokenFound({ status: true, token: currentToken });
    } else {
      setTokenFound(false);
    }
  } catch (err) {
  }
};

getTokens();
export const registerOnMessageListener = (callback) => {
  return onMessage(messaging, (payload) => {
    if (typeof callback === "function") {
      callback(payload);
    }
  });
};

export const onMessageListener = () =>
  new Promise((resolve) => {
    onMessage(messaging, (payload) => {
      resolve(payload);
    });
  });

